export const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export const accountTypes = [
  {
    id: "Internal",
    text: "Internal",
  },
  {
    id: "External",
    text: "External",
  },
];

export const accountStatus = [
  {
    id: "Active",
    text: "Active",
  },
  {
    id: "Block",
    text: "Block",
  },
];

export const assignmentList = [
  {
    id: "CIT",
    text: "CIT",
  },
  {
    id: "ATM",
    text: "ATM",
  },
  {
    id: "HUB",
    text: "HUB",
  },
  {
    id: "FLM",
    text: "FLM",
  },
  {
    id: "Customer",
    text: "Customer",
  },
  {
    id: "NA",
    text: "NA",
  },
];

export const formDefaultValues = { roleName: "", description: "" };

export const formValidationRules = {
  role: "",
  description: "",
  permissions: "",
};
